import React from "react";
import { Box } from "@material-ui/core";
import { useStyles } from "./styles";
import { useFormContext } from "react-hook-form";
import NoComment from "Components/formControls/HookFields/NoData/NoComment";
import ParentMessageDisplay from "./ParentMessageDisplay";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

const Conversation = () => {
  const classes = useStyles();
  const { watch } = useFormContext();
  const { comments, visionId } = watch();
  return (
    <Box px={0.5} pb={2} pt={1} className={classes.root}>
      {comments.length ? (
        <SimpleBar
          forceVisible="y"
          style={{ height: "100%" }}
          data-simplebar-auto-hide="false"
        >
          <ul className={classes.conversationList}>
            {comments.map(res => (
              <ParentMessageDisplay
                parentComment={{ ...res, visionId }}
                comments={comments}
              />
            ))}
          </ul>
        </SimpleBar>
      ) : (
        <NoComment />
      )}
    </Box>
  );
};

export default Conversation;
